"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TertiaryButton = function TertiaryButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      disabled = _ref.disabled,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["onClick", "label", "disabled", "children"]);

  return /*#__PURE__*/_react.default.createElement(StyledTertiaryButton, _extends({
    onClick: onClick,
    disabled: disabled
  }, otherProps), label ? label : children);
};

var StyledTertiaryButton = _styledComponents.default.button.withConfig({
  displayName: "StyledTertiaryButton"
})(["font-family:", ";font-size:1.6rem;line-height:120%;color:", ";cursor:", ";transition:0.15s ease-in-out;border:0;background-color:transparent;&:hover{color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ui.disabled;
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? '' : 'pointer';
}, function (_ref5) {
  var theme = _ref5.theme,
      disabled = _ref5.disabled;
  return disabled ? theme.ui.disabled : theme.brand.primary;
});

TertiaryButton.propTypes = {
  /** Text to be displayed. */
  label: _propTypes.string,
  disabled: _propTypes.bool,
  otherProps: _propTypes.object,

  /** Children nodes */
  children: _propTypes.node,

  /** Function to be ran when this button is clicked. */
  onClick: _propTypes.func.isRequired
};
TertiaryButton.defaultProps = {
  otherProps: {},
  onClick: function onClick() {}
};
var _default = TertiaryButton;
exports.default = _default;